var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketChangeArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58296 0C7.90511 2.38718e-05 8.16598 0.260854 8.16597 0.583008V5.25C8.1658 5.57192 7.90977 5.83286 7.58785 5.83301C7.26579 5.833 7.00013 5.57202 6.99996 5.25V1.99023L0.995073 7.99512C0.767275 8.22292 0.398662 8.2229 0.170855 7.99512C-0.0569515 7.76731 -0.0569515 7.3987 0.170855 7.1709L6.17476 1.16602H2.91597C2.59393 1.16586 2.33296 0.905079 2.33296 0.583008C2.33297 0.260933 2.59393 0.000144513 2.91597 0H7.58296Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketChangeArrowIcon);
export default __webpack_public_path__ + "static/media/MarketChangeArrowIcon.3567ff302728954405b3ba323c1a3703.svg";
export { ForwardRef as ReactComponent };